import Button from "components/Form/Button";
import ErrorToast from "components/Toasts/Error";
import SuccessToast from "components/Toasts/Success";
import { CoreContext } from "context/CoreContext";
import { useContext, useState } from "react";
import { useDropzone } from "react-dropzone";
import { PostImage } from "services/api";
import { Create } from "services/deliveries";
import {
  AssetsContent,
  AssetsContentItem,
  AssetsContentItemAction,
  AssetsContentItemActionIcon,
  AssetsContentItemContent,
  AssetsContentItemIcon,
  AssetsContentItemText,
  ModalContainer,
  UploadContent,
  UploadContentIcon,
  UploadContentText,
} from "./styled";

export default function ModalAddDelivery() {
  const [preview, setPreview] = useState([]);
  const [loading, setLoading] = useState(false);
  const { modal, setModal, user } = useContext(CoreContext);

  const close = () => {
    setModal(null);
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true, // ⚠️ Evita abrir o seletor de arquivos ao clicar no botão
    onDrop: (acceptedFiles) => {
      setPreview(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const addDeliveries = async () => {
    setLoading(true);

    const filesUploaded = await Promise.all(
      preview.map(async (file) => await PostImage(file))
    );
    console.log(filesUploaded);
    if (filesUploaded.some((file) => file.error)) {
      setLoading(false);
      return ErrorToast({
        message: "Erro ao fazer upload dos arquivos",
      });
    }
    await Promise.all(
      filesUploaded.map(
        async (file) =>
          await Create({
            data: {
              campaign: modal?.item.id,
              file: file,
              uploadBy: user.id,
              uploadAt: new Date(),
              isVideo: [
                "mov",
                "mp4",
                "wmv",
                "avi",
                "mkv",
                "webm",
              ].includes(file.format.toLowerCase()),
            },
          })
      )
    );

    SuccessToast({ message: "Entregáveis importados com sucesso" });
    setLoading(false);
    close();
    modal?.reload();
  };

  return (
    <>
      <ModalContainer>
        <div
          {...getRootProps()} // Agora, toda a área aceita drag and drop
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            width: "480px",
            background: "rgba(255, 255, 255, 1)",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <input {...getInputProps()} style={{ display: "none" }} />

          <img
            src="/icons/close.svg"
            width={"10px"}
            height={"10px"}
            style={{ alignSelf: "end", cursor: "pointer" }}
            onClick={close}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
              width: "448px",
              background: "rgba(255, 255, 255, 1)",
              borderRadius: "8px",
              padding: "16px",
              border: "2px dashed #CCC4D8",
            }}
          >
            <img src="/images/folder.png" width={"64px"} height={"64px"} />
            <p style={{ margin: 0, fontSize: "16px", fontWeight: 500 }}>
              Importe os entregáveis desta campanha
            </p>
            <p style={{ margin: 0, fontSize: "14px" }}>
              Faça o upload dos arquivos de entregáveis.
            </p>

            {!preview.length && (
              <UploadContent onClick={open} style={{ cursor: "pointer" }}>
                <UploadContentIcon />
                <UploadContentText>
                  ou arraste o arquivo para esta área
                </UploadContentText>
              </UploadContent>
            )}

            {preview.length ? (
              <>
                <CardsDeliveries preview={preview} setPreview={setPreview} />
                <div
                  style={{
                    width: "243px",
                    height: "48px",
                  }}
                >
                  <Button
                    loading={loading}
                    onClick={(e) => {
                      e.stopPropagation(); // ⚠️ Impede que o botão acione o dropzone
                      if (loading) return;
                      addDeliveries();
                    }}
                    primary
                    nospace
                  >
                    IMPORTAR ENTREGÁVEIS
                  </Button>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </ModalContainer>
    </>
  );
}

function CardsDeliveries({ preview, setPreview }) {
  return (
    <>
      <AssetsContent>
        {preview.map((file, key) => (
          <AssetsContentItem key={key}>
            <AssetsContentItemContent>
              {file.type.includes("image") ? (
                <img
                  src={file.preview}
                  width={"38px"}
                  height={"38px"}
                  style={{ borderRadius: "12px" }}
                />
              ) : (
                <AssetsContentItemIcon />
              )}

              <AssetsContentItemText>{file?.name}</AssetsContentItemText>
            </AssetsContentItemContent>

            <AssetsContentItemAction
              onClick={() => {
                const newPreview = [...preview];
                newPreview.splice(key, 1);
                setPreview(newPreview);
              }}
            >
              <AssetsContentItemActionIcon />
            </AssetsContentItemAction>
          </AssetsContentItem>
        ))}
      </AssetsContent>
    </>
  );
}
